/**
 * Shopify's predictive search / search results can return a product URL
 * pointing at whichever variant the search index happened to match (e.g.
 * "?variant=<xs-agave-blue-rib-id>"), completely independent of stock. A
 * shopper who typed "maya agave" can land on the product with an
 * out-of-stock XS pre-selected and "Sold out" shown, even though other
 * sizes of that same color are in stock — Shopify's normal "fall back to
 * the first available variant" logic only kicks in when there's NO
 * ?variant= param, and here there is one.
 *
 * This only intervenes when: the URL carries Shopify's own search/predictive
 * search tracking params (_pos/_psq/_psid/_ss — never set by this theme,
 * only by Shopify's search attribution), a ?variant= param is present, that
 * variant is the one currently selected, it's unavailable, and a different,
 * available variant exists to switch to. It leaves the URL and selection
 * untouched in every other case (manual links, marketing/email deep links,
 * variants that are actually in stock, fully sold-out products).
 */
(function () {
  var SEARCH_PARAM_KEYS = ['_pos', '_psq', '_psid', '_ss'];

  function getSearchLinkedVariantId() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return null;

    var fromSearch = SEARCH_PARAM_KEYS.some(function (key) {
      return params.has(key);
    });
    return fromSearch ? variantId : null;
  }

  function stripVariantParam() {
    var url = new URL(window.location.href);
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url.toString());
  }

  function applyVariant(root, target) {
    var optionKeys = ['option1', 'option2', 'option3'];
    var groups = root.querySelectorAll('.product-form__input');
    var lastChanged = null;

    groups.forEach(function (group, index) {
      var targetValue = target[optionKeys[index]];
      if (targetValue == null) return;

      var radio = Array.prototype.find.call(group.querySelectorAll('input[type="radio"]'), function (input) {
        return input.value === targetValue;
      });
      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          lastChanged = radio;
        }
        return;
      }

      var select = group.querySelector('select');
      if (!select) return;
      var option = Array.prototype.find.call(select.options, function (opt) {
        return opt.value === targetValue;
      });
      if (option && !option.hasAttribute('selected')) {
        var prevSelected = select.querySelector('option[selected]');
        if (prevSelected) prevSelected.removeAttribute('selected');
        option.setAttribute('selected', 'selected');
        select.value = targetValue;
        lastChanged = select;
      }
    });

    if (lastChanged) {
      lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function init(root) {
    var linkedVariantId = getSearchLinkedVariantId();
    if (!linkedVariantId) return;

    var selectedNode = root.querySelector('[data-selected-variant]');
    var allVariantsNode = root.querySelector('[data-all-variants]');
    if (!selectedNode || !allVariantsNode) return;

    var selected;
    var allVariants;
    try {
      selected = JSON.parse(selectedNode.textContent);
      allVariants = JSON.parse(allVariantsNode.textContent);
    } catch (e) {
      return;
    }

    if (!selected || String(selected.id) !== String(linkedVariantId) || selected.available !== false) {
      return;
    }

    var target = allVariants.filter(function (v) {
      return v.available;
    })[0];
    if (!target || String(target.id) === String(selected.id)) return;

    applyVariant(root, target);
    stripVariantParam();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('variant-selects').forEach(init);
  });
})();
